import { ReservationOptions } from '@mews-commander/types';

export const isOnlineCheckedOut = ({ ownerCheckedOut }: ReservationOptions) => ownerCheckedOut;
